import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import type { MenuStoreMenuListItem } from '../../models/menu-store.entity';
import { MenuStoreCard } from './menu-store-card.component';
import { MenuStoreVirtuosoPagedGrid } from './menu-store-virtuoso-paged-grid.component';

export type MenuStoreBrowseGridProps = {
    /** 当前已加载的商店卡片数据（随分页追加变长） */
    items: readonly MenuStoreMenuListItem[];
    /** 为 true 时表示正在请求下一页，底部展示加载指示 */
    loadingMore: boolean;
    /** 触底或可视区域不足时触发，由外层幂等拉取下一页 */
    onLoadMore: () => void;
    /** 用户点击卡片进入详情 */
    onOpenItem: (item: MenuStoreMenuListItem) => void;
    /** 与首屏搜索词组合：切换已提交关键词时重置 Virtuoso 内部滚动位置 */
    listResetKey: string;
};

/**
 * 菜单商店列表：虚拟栅格 + 触底分页（商店首页 / 我的菜单 Tab 共用样式）。
 */
export const MenuStoreBrowseGrid: React.FC<MenuStoreBrowseGridProps> = (props) => {
    const { items, loadingMore, onLoadMore, onOpenItem, listResetKey } = props;

    const itemContent = useCallback(
        (_index: number, item: MenuStoreMenuListItem) => (
            <Box className="menu-store-card-wrap">
                <MenuStoreCard item={item} onOpen={() => onOpenItem(item)} />
            </Box>
        ),
        [onOpenItem],
    );

    const computeItemKey = useCallback((_index: number, item: MenuStoreMenuListItem) => item._id, []);

    return (
        <MenuStoreVirtuosoPagedGrid<MenuStoreMenuListItem>
            listResetKey={listResetKey}
            items={items}
            loadingMore={loadingMore}
            onLoadMore={onLoadMore}
            computeItemKey={computeItemKey}
            itemContent={itemContent}
            listClassName="menu-store-page__card-flow menu-store-browse-grid__list"
            itemClassName="menu-store-page__card-flow-item menu-store-browse-grid__cell"
        />
    );
};
